// extracted by mini-css-extract-plugin
export default {"InviteFriendPop":"CashoutMod_InviteFriendPop__j6AWw","modalHeader":"CashoutMod_modalHeader__WhAfg","formControl":"CashoutMod_formControl__Offxb"};